import styled from '@emotion/styled';
import { fontSizes } from 'app/typography';

export const StyledFooter = styled.div`
  border-top: 1px solid var(--color-border-medium);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 32px;
  padding-left: 12px;
  padding-right: 12px;
  > .apply-button {
    height: unset;
    font-size: ${fontSizes.small};
    line-height: 1;
  }
  column-gap: 20px;
`;
